import { create } from 'zustand';

interface initDataState {
  param: any;
  bindParam: any;
  result: any;
  initPayload: any;
  payload: any;
  bind: (result: { data: any }) => void;
  bindPayload: (payload: { data: any }) => void;
}

// 전세액
export const initRentFPayload = {
  name: '', //사용자명
  acct_year: '', //연말정산   년도
  co_cd: '', //회사코드
  co_id: '', //사번
  in_data_seqid: '', //입력데이터 sequence
  loan_date: '', // 차입일
  amt: 0, // 금액(일반)
  htx_amt: 0, // 금액(국세청)
  is_htx_pdf: 'Y', //국세청사용여부
  question_status: '', //설문상태
};

/**
  전세액
**/
export const rentFDataStore = create<initDataState>(set => ({
  param: { initialSeq: 0 },
  bindParam: (bind: any) =>
    set(state => ({
      ...state,
      param: { ...state.param, ...bind },
    })),
  result: [],
  bind: (data: any) =>
    set(state => ({
      ...state,
      result: { ...state.result, ...data },
    })),
  initPayload: initRentFPayload,
  payload: initRentFPayload,
  bindPayload: (data: any) =>
    set(state => ({
      ...state,
      payload: { ...state.payload, ...data },
    })),
}));
